import { render, staticRenderFns } from "./OrganizationSettingsAddUser.vue?vue&type=template&id=4a0e60aa&scoped=true"
import script from "./OrganizationSettingsAddUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationSettingsAddUser.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationSettingsAddUser.vue?vue&type=style&index=0&id=4a0e60aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e60aa",
  null
  
)

export default component.exports